import Table from '../../../table';

namespace('IO.Views.FirewallPolicies', function (exports) {
  'use strict';

  var Index = Table.extend({
    dom: {
      DATATABLES: 'table.display',
      CLONE_ACTION: '.clone-policy',
      DELETE_ACTION: '.delete-policy',
      CHECKED_POLICY: '.row-checkbox:checked',
      ONE_SELECTION_ACTION: '.dropdown-toggleable-option-one',
      MANY_SELECTION_ACTION: '.dropdown-toggleable-option-many',
      SELECTION_ACTION: '.dropdown-toggleable-option',
      TAB: '.tabs dd',
    },

    opts: {
      aoColumnDefs: [
        {
          aTargets: [0],
          mRender: function (data, type, full) {
            return (
              '<form class="custom"><input type="checkbox" name="policy-checkbox"  data-name="' +
              full[2] +
              '" class="row-checkbox row' +
              data +
              '-checkbox" value="' +
              data +
              '"  /></form>'
            );
          },
        },
      ],
      ajaxSource: 'firewalls.json',
      controller: 'firewalls',
      filter: true,
      fixed: false,
      fixedColumnWidth: 70,
      fixedColumns: 2,
      sorting: [[1, 'asc']],
      title: 'Click to edit',
    },

    events: function () {
      var events = {};

      events['click ' + this.dom.CLONE_ACTION] = '_clonePolicy';
      events['click ' + this.dom.DELETE_ACTION] = '_deletePolicy';
      return events;
    },

    afterRender: function () {
      this.listenTo(
        this.dataTable,
        'dataTables:row-selected',
        this._handleActionsDropdown,
      );
    },

    _clonePolicy: function (e) {
      var target = e.currentTarget,
        $selectedPolicy = this.$(this.dom.CHECKED_POLICY);

      e.preventDefault();
      window.location.href =
        target.href + '/' + $selectedPolicy.val() + '/clone';
    },

    onDestroy: function () {
      if (this.confirmationModal) {
        this.confirmationModal.destroy();
      }

      if (this.confirmationStringModal) {
        this.confirmationStringModal.destroy();
      }
    },

    _deletePolicy: function (e) {
      var message = 'You are about to delete this resource. Are you sure?';

      if (typeof this.confirmationModal === 'undefined') {
        this.confirmationModal = new IO.Views.ConfirmationModal({
          el: '#confirmation-modal',
          closable: false,
        });
      }

      this.confirmationModal.show(message, (awnser) => {
        if (awnser) {
          this._showConfirmStringModal(e);
        }
      });

      return false;
    },

    _showConfirmStringModal: function (evt) {
      var $selectedCheckboxes = this.$(this.dom.CHECKED_POLICY),
        $el = $(evt.currentTarget),
        baseURL = $el.prop('href'),
        ids;

      if (typeof this.confirmationStringModal === 'undefined') {
        this.confirmationStringModal = new ConfirmationStringModal({
          confirm_string: 'DELETE',
          closable: false,
        });
      } // eslint-disable-line camelcase

      this.confirmationStringModal.answer((confirmed) => {
        this.confirmationStringModal.destroy();
        this.confirmationStringModal = undefined;
        if (confirmed) {
          ids = _.map($selectedCheckboxes, function (checkbox) {
            return checkbox.value;
          });
        }

        $.ajax({
          type: 'DELETE',
          url: baseURL + '/destroy_multiple',
          data: { 'policies[]': ids },
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          },
        }).done(function () {
          Turbolinks.visit(location.href);
        });
      });
    },

    _handleActionsDropdown: function (elements) {
      var empty = elements.length === 0,
        hasOne = elements.length === 1 ? 'inline-block' : 'none',
        hasMany = elements.length > 1 ? 'inline-block' : 'none';

      if (empty) {
        this.$(this.dom.SELECTION_ACTION).hide();
      }

      this.$(this.dom.MANY_SELECTION_ACTION).css({ display: hasMany });
      this.$(this.dom.ONE_SELECTION_ACTION).css({ display: hasOne });
    },
  });

  exports.Index = Index;
});
